import {
  clearEducationStateForUser,
  readEducationState,
  updateEducationState,
  upsertReleaseRecord,
} from "./localStorageAdapter";

/**
 * Persistence adapter — localStorage today, Supabase sync in a future phase.
 */
export function createPersistenceAdapter(userId) {
  return {
    load() {
      return readEducationState(userId);
    },

    save(state) {
      return updateEducationState(userId, () => state);
    },

    update(updater) {
      return updateEducationState(userId, updater);
    },

    clear() {
      clearEducationStateForUser();
    },

    updateRelease(releaseId, patch) {
      return updateEducationState(userId, (state) =>
        upsertReleaseRecord(state, releaseId, patch),
      );
    },

    updateSettings(partialSettings) {
      return updateEducationState(userId, (state) => ({
        ...state,
        settings: {
          ...state.settings,
          ...partialSettings,
        },
      }));
    },
  };
}
